import React from 'react';
import { Typography, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  totalInvestments: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  sectionDivider: {
    marginTop: `${theme.spacing(3)} !important`,
    marginBottom: `${theme.spacing(3)} !important`,
  },
  title: {
    marginBottom: theme.spacing(2),
    textTransform: 'uppercase',
  },
  bigValue: {
    marginBottom: theme.spacing(2),
  },
}));

const Totals = ({totalSavings, totalSavingsMonthly, totalSavingsWeekly, totalSavingsDaily}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Divider className={classes.sectionDivider} />
      <Typography variant='h5' className={classes.title}>
        Total savings this year
      </Typography>
      <Typography variant='h2' className={classes.bigValue}>
        $298K
      </Typography>
      <Divider className={classes.sectionDivider}/>
      <div className={classes.totalInvestments}>
        <div className={classes.item}>
          <Typography variant='subtitle1' className={classes.subtitle}>
            Today
          </Typography>
          <Typography variant='h5' className={classes.smallValue}>
            $886
          </Typography>
        </div>
        <Divider orientation='vertical' flexItem />
        <div className={classes.item}>
          <Typography variant='subtitle1' className={classes.subtitle}>
            This week
          </Typography>
          <Typography variant='h5' className={classes.smallValue}>
            $6,208
          </Typography>
        </div>
        <Divider orientation='vertical' flexItem />
        <div className={classes.item}>
          <Typography variant='subtitle1' className={classes.subtitle}>
            This month
          </Typography>
          <Typography variant='h5' className={classes.smallValue}>
            $24,833
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Totals;
